import { identity, pipe } from 'fp-ts/function';
import { array } from 'fp-ts';
import { FeatureFlagServiceProps } from '@mews/framework';
import { FeatureFlag } from '@mews-commander/enums';
import { Option } from '@mews-commander/types';
import { ifElse } from '@mews/fp';
import { EnumValue } from '@mews/enumify';
import { createOption } from '@mews-commander/ui';
import { CancellationReason } from '@mews-commander/legacy-data-structures';
import { COVID_19_LABEL, COVID_19_VALUE } from './constants';

interface GetCancellationReasonOptionsParams extends FeatureFlagServiceProps {
    localizeEnum: (enumValue: EnumValue) => string;
}

export const getCancellationReasonOptions = ({
    featureFlagService,
    localizeEnum,
}: GetCancellationReasonOptionsParams): Array<Option> =>
    pipe(
        CancellationReason.enumValues,
        ifElse(
            () => featureFlagService.hasFlag(FeatureFlag.bookingEngineOptionalReservations),
            identity,
            array.filter(({ value }) => value !== CancellationReason.BookingAbandoned.value)
        ),
        array.map((enumValue) =>
            createOption({
                // @ts-expect-error $TSFixMeError: Type 'number' is not assignable to type 'string'.
                value: enumValue.value,
                label: localizeEnum(enumValue),
            })
        ),
        array.prepend(
            createOption({
                value: COVID_19_VALUE,
                label: COVID_19_LABEL,
            })
        )
    );
